import styled from 'styled-components';


export const StyledDeleteModal = styled.div`
	.title {
		text-align: center;
		font-size: 28px;
		font-weight: 600;
		color: #333336;
	}

	.description {
		margin-top: 12px;
		font-size: 14px;
		font-weight: 500;
		color: #abb3bb;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		gap: 24px;
		margin-top: 18px;
	}
	
	.dep-pack {
		margin-top: 20px;
		
		b {
			margin-bottom: 10px;
			display: block;
		}
		
		ul {
			list-style-type: disc;
			padding-left: 15px;
			
			a { color: #4594FF;}
		}
	}
`;
